import type { EventMapping } from '@/data'
import api from '..'

export async function createPixelEvent(
  pixelId: string,
  event: EventMapping,
): Promise<EventMapping> {
  const res = await api.post(`/pixels/${pixelId}/events`, event)
  return res.data.data
}

export async function updatePixelEvent(
  pixelId: string,
  eventId: number,
  event: EventMapping,
): Promise<EventMapping> {
  const res = await api.put(`/pixels/${pixelId}/events/${eventId}`, event)
  return res.data.data
}

export async function deletePixelEvent(
  pixelId: string,
  eventId: number,
): Promise<void> {
  await api.delete(`/pixels/${pixelId}/events/${eventId}`)
}
